import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Button, Container } from "react-bootstrap";
import API_BASE from "../api";
import "./ListaEDPs.css";

const ListaEDPs = () => {
  const [edps, setEdps] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [edpSeleccionado, setEdpSeleccionado] = useState(null);
  const detalleRef = useRef();

  useEffect(() => {
    axios
      .get(`${API_BASE}/edp-completo`)
      .then((res) => setEdps(res.data))
      .catch((err) => console.error("❌ Error al obtener EDPs:", err));
  }, []);

  // 🔥 FIX: protección contra undefined
  const edpsFiltrados = edps.filter((e) => {
    const texto =
      (e.encabezado?.subcontratista || "") +
      (e.encabezado?.obra || "") +
      (e.encabezado?.fecha || "");

    return texto.toLowerCase().includes(busqueda.toLowerCase());
  });

  const imprimir = () => {
    const contenido = detalleRef.current.innerHTML;
    const win = window.open("", "", "width=1024,height=768");

    const estiloForzado = `
      <style>
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        body { font-family: Segoe UI, sans-serif; padding: 20px; }

        table { width: 100%; border-collapse: collapse; font-size: 13px; }

        th, td {
          border: 1px solid #ccc;
          padding: 6px;
          text-align: center;
        }

        h2 { text-align: center; margin-bottom: 20px; }

        .btn-edp-ver,
        .btn-edp-eliminar,
        .busqueda-facturas-wrapper,
        .d-flex {
          display: none !important;
        }
      </style>
    `;

    win.document.write(`
      <html>
        <head>
          <title>Estado de Pago</title>
          ${estiloForzado}
        </head>
        <body>${contenido}</body>
      </html>
    `);

    win.document.close();
    win.onload = () => win.print();
  };

  return (
    <Container style={{ padding: 20 }}>
      <h3>📄 Listado de Estados de Pago</h3>

      <input
        type="text"
        placeholder="🔍 Buscar..."
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        style={{ marginBottom: 20, padding: 8, width: "100%" }}
      />

      <table className="tabla-edps">
        <thead>
          <tr>
            <th>#</th>
            <th>Subcontratista</th>
            <th>Obra</th>
            <th>Fecha</th>
            <th>Estado Pago</th>
            <th>Acciones</th>
          </tr>
        </thead>

        <tbody>
          {edpsFiltrados.map((edp, i) => (
            <tr key={edp._id || i}>
              <td>{i + 1}</td>
              <td>{edp.encabezado?.subcontratista || "-"}</td>
              <td>{edp.encabezado?.obra || "-"}</td>
              <td>{edp.encabezado?.fecha || "-"}</td>
              <td>{edp.encabezado?.estadoPago || "-"}</td>
              <td>
                <button onClick={() => setEdpSeleccionado(edp)}>
                  Ver
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {edpSeleccionado && (
        <div style={{ marginTop: 30 }}>
          <div ref={detalleRef}>
            <h2>📋 RESUMEN ESTADO DE PAGO</h2>

            <table>
              <tbody>
                <tr>
                  <td>SUBCONTRATISTA: {edpSeleccionado.encabezado?.subcontratista}</td>
                  <td>EMPRESA: {edpSeleccionado.encabezado?.empresa}</td>
                </tr>
                <tr>
                  <td>OBRA: {edpSeleccionado.encabezado?.obra}</td>
                  <td>CONTRATO: {edpSeleccionado.encabezado?.contrato}</td>
                </tr>
                <tr>
                  <td>FECHA: {edpSeleccionado.encabezado?.fecha}</td>
                  <td>ESTADO: {edpSeleccionado.encabezado?.estadoPago}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: 20 }}>
              <p>
                <strong>TOTAL:</strong>{" "}
                {edpSeleccionado.totales?.total?.toLocaleString() || 0}
              </p>
            </div>
          </div>

          <button onClick={() => setEdpSeleccionado(null)}>
            Cerrar
          </button>

          <button onClick={imprimir}>
            Imprimir
          </button>
        </div>
      )}
    </Container>
  );
};

export default ListaEDPs;